import { createAsyncTypes } from 'utils/ActionCreator'

const key = 'SpearPhishingAgent'

export const GET_PSIMA_COMPANIES_ASYNC = createAsyncTypes('GET_PSIMA_COMPANIES', key)
export const GET_MONITORING_STATUS_INFO_ASYNC = createAsyncTypes('GET_MONITORING_STATUS_INFO', key)
export const GET_CAMPAIGNS_LIST_ASYNC = createAsyncTypes('GET_CAMPAIGNS_LIST', key)
export const SEND_SIMULATIONS_ASYNC = createAsyncTypes('SEND_SIMULATIONS', key)
export const GET_SIMULATION_LIST_ASYNC = createAsyncTypes('GET_SIMULATION_LIST', key)
export const GET_LEVEL_COUNTS_ASYNC = createAsyncTypes('GET_LEVEL_COUNTS', key)
export const GET_METRIC_BANNER_ASYNC = createAsyncTypes('GET_METRIC_BANNER', key)
export const GET_PARTICIPANT_DETAILS_ASYNC = createAsyncTypes('GET_PARTICIPANT_DETAILS', key)
export const GET_EMAIL_PREVIEW_ASYNC = createAsyncTypes('GET_EMAIL_PREVIEW', key)
export const POST_EMAIL_FEEDBACK_ASYNC = createAsyncTypes('POST_EMAIL_FEEDBACK', key)
export const POST_CARD_FEEDBACK_ASYNC = createAsyncTypes('POST_CARD_FEEDBACK', key)
export const GET_SIMULATIONS_META_ASYNC = createAsyncTypes('GET_SIMULATIONS_META', key)

export const SET_SELECTED_CAMPAIGNS = `${key}/SET_SELECTED_CAMPAIGNS`
export const SET_EXCLUDED_PARTICIPANTS = `${key}/SET_EXCLUDED_PARTICIPANTS`
export const SET_RISK_LEVEL_SELECTED_FILTERS = `${key}/SET_RISK_LEVEL_SELECTED_FILTERS`
export const SET_CARDS_ORDERING = `${key}/SET_CARDS_ORDERING`
export const SET_PLACEHOLDER_FILTER = `${key}/SET_PLACEHOLDER_FILTER`
export const SET_SINGLE_CAMPAIGN_ID = `${key}/SET_SINGLE_CAMPAIGN_ID`
export const SET_STATUS_SELECTED_FILTERS = `${key}/SET_STATUS_SELECTED_FILTERS`
export const SET_SIMULATION_DEPARTMENTS = `${key}/SET_SIMULATION_DEPARTMENTS`
export const SET_SIMULATION_DATE_RANGE = `${key}/SET_SIMULATION_DATE_RANGE`
export const SET_SIMULATION_SORT = `${key}/SET_SIMULATION_SORT`
export const EXPORT_SIMULATIONS_CSV_ASYNC = createAsyncTypes('EXPORT_SIMULATIONS_CSV', key)
export const PAGINATE_SIMULATIONS = `${key}/PAGINATE_SIMULATIONS`
export const LOAD_MORE_CAMPAIGNS = `${key}/LOAD_MORE_CAMPAIGNS`
export const RESET_SIMULATION_PARTICIPANTS = `${key}/RESET_SIMULATION_PARTICIPANTS`

export const CAMPAIGNS_PAGE_SIZE = 40
export const SIMULATIONS_PAGE_SIZE = 25
export const SEND_SIMULATIONS_BATCH_SIZE = 10
export const MAX_CARD_PARTICIPANTS = 1000

export const PSIMA_NOT_ENABLED_ERROR_CODE = 'psima_not_enabled'

export const PSIMA_PAGE_STATUS = {
  REDIRECT: 'redirect',
  LOADING: 'loading',
  CHOOSE_COMPANY: 'choose-company',
  TENANT_UNAVAILABLE: 'tenant-unavailable',
  NOT_ENABLED: 'not-enabled',
  ACCESS_DENIED: 'access-denied',
  READY: 'ready',
}

export const MOCK_TIME = 'Jan 01, 0000, 00:00 AM'

export const SCHEDULE_STATUSES_VALUES = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}

export const SCHEDULE_STATUSES_LABELS = {
  [SCHEDULE_STATUSES_VALUES.ACTIVE]: 'Active Agent',
  [SCHEDULE_STATUSES_VALUES.INACTIVE]: 'Inactive Agent',
}

export const RISK_LEVELS_VALUES = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
}

export const RISK_LEVELS_LABELS = {
  [RISK_LEVELS_VALUES.LOW]: 'Low',
  [RISK_LEVELS_VALUES.MEDIUM]: 'Medium',
  [RISK_LEVELS_VALUES.HIGH]: 'High',
}

export const ALL_RISK_LEVEL_VALUE = 'all'

export const CARD_ORDERING_VALUES = {
  LEVEL: 'level',
  MOST_RECENT: 'most_recent',
  EXPIRES_AT: 'expires_at',
}

export const CARD_ORDERING_LABELS = {
  [CARD_ORDERING_VALUES.LEVEL]: 'Risk level',
  [CARD_ORDERING_VALUES.MOST_RECENT]: 'Most recent',
  [CARD_ORDERING_VALUES.EXPIRES_AT]: 'Effective until',
}

export const DEFAULT_CARD_ORDERING = CARD_ORDERING_VALUES.LEVEL

export const SIMULATION_STATUSES_VALUES = {
  SENDING: 'sending',
  ACTIVE: 'active',
  COMPLETED: 'completed',
}

export const SIMULATION_STATUSES_LABELS = {
  [SIMULATION_STATUSES_VALUES.SENDING]: 'Sending',
  [SIMULATION_STATUSES_VALUES.ACTIVE]: 'Active',
  [SIMULATION_STATUSES_VALUES.COMPLETED]: 'Completed',
}

export const PARTICIPANT_STATUSES_VALUES = {
  REPORTED: 'reported',
  CLICKED: 'clicked',
  OPENED: 'opened',
  NOT_STARTED: 'not_started',
}

export const PARTICIPANT_STATUSES_LABELS = {
  [PARTICIPANT_STATUSES_VALUES.REPORTED]: 'Reported',
  [PARTICIPANT_STATUSES_VALUES.CLICKED]: 'Clicked',
  [PARTICIPANT_STATUSES_VALUES.OPENED]: 'Opened',
  [PARTICIPANT_STATUSES_VALUES.NOT_STARTED]: 'Not started',
}

// TLP (training-landing-page) completion status for a participant's simulation
// mail. Values mirror the backend `psima.enums.TrainingLandingStatus`; a missing
// status (no training row) arrives as null and renders as "—".
export const TLP_STATUSES_VALUES = {
  TRAINED: 'trained',
  UNTRAINED: 'untrained',
}

export const TLP_STATUSES_LABELS = {
  [TLP_STATUSES_VALUES.TRAINED]: 'Completed',
  [TLP_STATUSES_VALUES.UNTRAINED]: 'Pending',
}

// Ordering for the Launched list. Risk-based ordering is out of scope here — card-level
// risk level is Phase 2 (see IC-50455).
export const LAUNCHED_ORDERING_VALUES = {
  LAUNCH_DATE: 'launch_date',
  LAST_ENGAGEMENT: 'last_engagement',
}

export const LAUNCHED_ORDERING_LABELS = {
  [LAUNCHED_ORDERING_VALUES.LAUNCH_DATE]: 'Launch date',
  [LAUNCHED_ORDERING_VALUES.LAST_ENGAGEMENT]: 'Last engagement',
}

export const DEFAULT_LAUNCHED_ORDERING = LAUNCHED_ORDERING_VALUES.LAUNCH_DATE

export const DEFAULT_SIMULATION_SORT = { key: 'createdAt', direction: 'desc' }

// Sort weight for the participants table inside a launched simulation:
// clicked + untrained -> clicked + trained -> opened -> not started -> reported.
export const PARTICIPANT_RISK_SORT_WEIGHTS = {
  CLICKED_UNTRAINED: 0,
  CLICKED_TRAINED: 1,
  OPENED: 2,
  NOT_STARTED: 3,
  REPORTED: 4,
}

// Planned maximum in the Reminders tooltip ("Sent n of 3").
export const MAX_TRAINING_REMINDERS = 3

export const LAUNCH_SOURCE_VALUES = {
  MANUAL: 'manual',
  QUICK_LAUNCH: 'quick_launch',
}
